import '@babel/polyfill';
import Vue from 'vue';
import store from './store';
import axios from "./modules/axios";
import "@/assets/style/style.scss";

// import vAddToCart from './components/add-to-cart.vue';
// import vCart from './components/cart.vue';
// import vDrawer from './components/drawer/index.vue';
// import vFilter from './components/filter.vue';
// import vSort from './components/sort.vue';
// import vThreeColumnsInfo from './components/three-columns-info.vue';

import storeLocator from './components/store-locator.vue';
import quizDiva from './components/quiz-diva.vue';

Vue.prototype.$http = axios;

const instances = [storeLocator, quizDiva];

instances.forEach(instance => {
  const elements = Array.prototype.slice.call(document.querySelectorAll(instance.selector));

  elements.forEach(el => new Vue({
    ...instance,
    el,
    // takes data attributes (data-*) on the root element and parses them as props
    propsData: Object.entries(el.dataset).reduce((sum, [key, val]) => ({
      ...sum,
      get [key]() {
       try {
         return JSON.parse(val);
       } catch(err) {
         return val;
       }
      }
    }), {})
  }));
});
